import { useEffect, useState } from "react"
import { Assessment } from "../../../../types/dataModel"
import useFetch from "../../../../hooks/useFetch"
import { API } from "../../../../common/Constants"
import PreLoader from "../../../../core/common/preLoader"
import { getAPIHeaders, isNotEmpty } from "../../../../common/Utils"
import FormFooter from "../../../../core/common/formFooter"

interface Props {
    id: number
    onSuccess: ()=> void
    onCancel: ()=>void
}

const ModifyAssessment = ({id, onSuccess, onCancel}:Props) => {
    const [formData, setFormData] = useState<Assessment | undefined>()
    const [msgBox, setMsgBox] = useState<any>({
      msg: "",
      error: false
    });
    const {isLoading, error, callFetch } = useFetch();

    useEffect(()=>{
      if(id > 0){
        fetchAssessment(id)
      }
    },[id])

    const reset = () => {
      setFormData({
        description:"",
        code:"",
        title:"",
        isLive: false,
        time: undefined,
        metadata: {},
      })
      resetMsgBox()
    }

    const exit = () => {
      reset()
      onCancel()
    }

    const resetMsgBox = () => {
      setMsgBox({
        msg: "",
        error: false
      })
    }

    const fetchAssessment = (id:number) => {
      callFetch(`${API.ASSESSMENT}/${id}`,
        'GET',
        getAPIHeaders(),
        null,
        null
    ).then((res)=>{
      if(res){
        setFormData({...res, time: res?.metadata?.Time})
      }
    });
  }


    useEffect(() => {
            if(error){
              if(error.response?.data){
                setMsgBox({msg: error.response?.data, error: true})
              } else{
                setMsgBox({msg: 'Something went wrong please try again later.', error: true})
              }
            }
    }, [error]);


    const handleSubmit = (event:any) => {
          event.preventDefault()
          if(!isNotEmpty(formData?.title)){
            setMsgBox({msg: "Please provide name", error: true})
          } else if(!isNotEmpty(formData?.description)){
            setMsgBox({msg: "Please provide description", error: true})
          } else if(!isNotEmpty(formData?.code)){
            setMsgBox({msg: "Please provide assessment code", error: true})
          } else if(!formData?.time || formData?.time === 0 ){
            setMsgBox({msg: "Please provide time greater than 0", error: true})
          } else {
            setMsgBox({msg:"",error: false})
            callFetch(API.ASSESSMENT,
                  formData?.id ? 'PUT' : 'POST',
                  getAPIHeaders(),
                  null,
                  {
                      id: formData?.id,
                      title: formData?.title,
                      description: formData?.description,
                      code: formData?.code,
                      time: formData?.time,
                  }
              ).then(()=>{
                setMsgBox({msg: "Saved Successfully", error: false})
                onSuccess()
              });
          }
    }

    return (
        <div className="modal-dialog modal-dialog-centered modal-md">
          <PreLoader showLoader={isLoading} />
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Assessment</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={exit}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Assessment Name <span className="text-danger"> *</span></label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData?.title}
                        onChange={(e)=>{
                          setFormData({
                            ...formData,
                            title: e.target.value
                          })
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Description <span className="text-danger"> *</span></label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData?.description}
                        onChange={(e)=>{
                          setFormData({
                            ...formData,
                            description: e.target.value
                          })
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Code <span className="text-danger"> *</span></label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData?.code}
                        onChange={(e)=>{
                          setFormData({
                            ...formData,
                            code: e.target.value
                          })
                        }}
                        disabled={formData?.id ? true : false}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Time (in minutes) <span className="text-danger"> *</span></label>
                      <input
                        type="number"
                        className="form-control"
                        value={formData?.time ? formData?.time : ""}
                        onChange={(e)=>{
                          setFormData({
                            ...formData,
                            time: e.target.value ? parseInt(e.target.value) : undefined
                          })
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <FormFooter
                    onCancel={exit}
                    onSave={handleSubmit}
                    error={msgBox.error}
                    message={msgBox.msg} 
                />
              </div>
            </form>
          </div>
      </div>
    )
}

export default ModifyAssessment